export default __webpack_public_path__ + "static/media/gemini.3acf6389.png";